import React from "react";

import client from "client/config";
import { QueryClientProvider } from "@tanstack/react-query";

import { RecoilRoot } from "recoil";
import Navigator from "./Navigator";

export default function Wholesaler() {
  return (
    <RecoilRoot>
      <QueryClientProvider client={client}>
        <Navigator />
      </QueryClientProvider>
    </RecoilRoot>
  );
}
